import React from "react";
import { Message, Grid } from "semantic-ui-react";
import WeightDisplay from "../../BoxReview/components/WeightDisplay";
import { BoxValidationResult } from "../../../lib/interfaces/ConveyorBox/IConveyorBox";

type Props = {
  imageFound: boolean;
  validationResult: BoxValidationResult;
  hasRX: boolean;
  shipping: any;
};

const ShippingMessageDisplay = (props: Props) => {
  const { shipping, validationResult, imageFound, hasRX } = props;

  const _getInstruction = (validationResult: BoxValidationResult) => {
    switch (validationResult) {
      case 1:
      case -1:
        return "Kör paketet genom vågen igen.";
      case 10:
      case 2:
        return "Kontrollera paketets innehåll";
      case 0:
      default:
        return "";
    }
  };

  return (
    <Message
      size="large"
      color={[0, -2].includes(validationResult) && imageFound ? "green" : "red"}
      className="validation-result"
    >
      <Grid columns={2}>
        {![0, -2].includes(validationResult) && (
          <Grid.Row>
            <Grid.Column>{_getInstruction(validationResult)}</Grid.Column>
          </Grid.Row>
        )}

        <Grid.Row>
          <Grid.Column width={16}>
            <WeightDisplay
              validationResult={validationResult}
              shippingWeight={shipping.shippingWeight}
              iPackMeasuredWeight={shipping.ipackMeasuredWeight}
              resetWeightCallback={() => {}}
              currentBox={{ hasRX: hasRX }}
              imageFound={imageFound}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Message>
  );
};
export default ShippingMessageDisplay;
